import React from 'react'

const jobNotFound = () => {
	return (
		<div className='w-full h-64'>
			<div className="flex flex-col bg-tcn-dark-blue rounded-lg text-white text-2xl p-8">
				<h1>Esta publicación no está activa, puedes conocer las ofertas disponibles acá: <a href="/ofertas"> Ver Ofertas</a> </h1>
			</div>
		</div>
	)
}

export default jobNotFound
